import React, { useCallback, useEffect, useState } from "react";
// import "./app.css";
// import { User } from "./User"; // component display user (see detail on /example directory)
import {
  LoginSocialGoogle,
  LoginSocialAmazon,
  LoginSocialFacebook,
  LoginSocialGithub,
  LoginSocialInstagram,
  LoginSocialLinkedin,
  LoginSocialMicrosoft,
  LoginSocialPinterest,
  LoginSocialTwitter,
  LoginSocialApple,
  LoginSocialTiktok,
} from "reactjs-social-login";

// CUSTOMIZE ANY UI BUTTON
import {
  FacebookLoginButton,
  GoogleLoginButton,
  GithubLoginButton,
  AmazonLoginButton,
  InstagramLoginButton,
  LinkedInLoginButton,
  MicrosoftLoginButton,
  TwitterLoginButton,
  AppleLoginButton,
} from "react-social-login-buttons";
import "./SocialLogin.css";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { SetUserSocialLoginCredentials } from "../../Utils/LocalStorage";
import { SocialLoginApi } from "../../Utils/Api/SocialLoginApi";
// import { ReactComponent as PinterestLogo } from "./assets/pinterest.svg";
// import { ReactComponent as TiktokLogo } from "./assets/tiktok.svg";

// REDIRECT URL must be same with URL where the (reactjs-social-login) components is locate
// MAKE SURE the (reactjs-social-login) components aren't unmounted or destroyed before the ask permission dialog closes
const REDIRECT_URI = window.location.href;

const SocialLogins = ({ SetLoadingFuc }) => {
  const [provider, setProvider] = useState("");
  const [profile, setProfile] = useState(null);

  const navigate = useNavigate();

  const SocialLoginApiHandler = async () => {
    const Data = {
      email: profile ? profile.email : "",
    };
    SetLoadingFuc(true);
    const SocialLoginRes = await SocialLoginApi(Data, () => {
      navigate("/");
    });
    if (SocialLoginRes === false) {
      toast.error("Internal Server Error!", {
        position: "top-center",
        width: "500px",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      SetLoadingFuc(false);
    } else {
      if (SocialLoginRes.success === true) {
        toast.success("Successfully logged in", {
          position: "top-center",
          width: "500px",
          autoClose: 6000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
        SetUserSocialLoginCredentials(SocialLoginRes);
        SetLoadingFuc(false);
        navigate("/dashboard");
      } else {
        toast.error(SocialLoginRes.message, {
          position: "top-center",
          width: "500px",
          autoClose: 6000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
        SetLoadingFuc(false);
      }
    }
  };

  useEffect(() => {
    if (profile) {
      SocialLoginApiHandler();
    }
  }, [profile]);

  return (
    <>
      <div className="App" id="socialLogin">
        <LoginSocialFacebook
          className="SocialLoginFacebookButton"
          access_type={"offline"}
          appId={process.env.REACT_APP_FB_APP_ID || ""}
          onResolve={({ provider, data }) => {
            setProvider(provider);
            setProfile(data);
          }}
          onReject={(err) => {
            console.log(err);
          }}
        >
          <FacebookLoginButton />
        </LoginSocialFacebook>

        <LoginSocialGoogle
          className="SocialLoginGoogleButton"
          client_id={process.env.REACT_APP_GG_APP_ID || ""}
          scope="openid profile email "
          // onLoginStart={onLoginStart}
          access_type={"offline"}
          onResolve={({ provider, data }) => {
            setProvider(provider);
            setProfile(data);
          }}
          onReject={(err) => {
            console.log(err);
          }}
        >
          <GoogleLoginButton />
        </LoginSocialGoogle>
      </div>
      {/* )} */}
    </>
  );
};

export default SocialLogins;
